import { render, staticRenderFns } from "./Ajutor_montator_dialog.vue?vue&type=template&id=b7dcca08&scoped=true"
import script from "./Ajutor_montator_dialog.vue?vue&type=script&lang=js"
export * from "./Ajutor_montator_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dcca08",
  null
  
)

export default component.exports